const darkTheme = {
  colors: {
    background: '#000000',
    backgroundSecondary: '#000000',
    text: '#FFFFFF',
    textSecondary: '#B3B3B3',
    primary: '#555555',
    secondary: '#000000',
    accent: '#777777',
    gray100: '#F5F5F5',
    gray200: '#E5E5E5',
    gray300: '#D4D4D4',
    gray400: '#A3A3A3',
    gray500: '#737373',
    gray600: '#000000',
    gray700: '#000000',
    gray800: '#000000',
    gray900: '#000000',
  },
  fonts: {
    main: "'Uxum Grotesque', -apple-system, BlinkMacSystemFont, sans-serif",
    heading: "'Uxum Grotesque', -apple-system, BlinkMacSystemFont, sans-serif",
  },
  breakpoints: { sm: '576px', md: '768px', lg: '992px', xl: '1200px' },
  transitions: { default: '0.3s ease' },
};

const lightTheme = darkTheme;

// Editorial teal-paper theme — calibrated to the Nicole Roberts reference
const editorialTheme = {
  colors: {
    background: '#FFFFFF',
    backgroundGradient: '#FFFFFF',
    backgroundAlt: '#F4F9FA',
    pillBg: '#F7F7F7',
    surface: '#FFFFFF',
    surfaceMint: '#F4F9FA',
    ink: '#0A0A0A',
    inkSoft: '#2B2B2B',
    inkMute: '#7A8A8C',
    rule: '#D6E9EB',
    accent: '#00959F',
    accentDeep: '#007C85',
    accentBg: '#E6F4F5',
    // Back-compat aliases
    text: '#0A0A0A',
    textSecondary: '#2B2B2B',
    primary: '#00959F',
    secondary: '#2B2B2B',
    backgroundSecondary: '#F4F9FA',
    gray100: '#FFFFFF',
    gray200: '#F4F9FA',
    gray300: '#D6E9EB',
    gray400: '#B9D6D9',
    gray500: '#7A8A8C',
    gray600: '#2B2B2B',
    gray700: '#141414',
    gray800: '#0A0A0A',
    gray900: '#F4F9FA',
  },
  fonts: {
    display: "'Uxum Grotesque', -apple-system, BlinkMacSystemFont, sans-serif",
    body: "'Uxum Grotesque', -apple-system, BlinkMacSystemFont, sans-serif",
    brand: "'Uxum Grotesque', -apple-system, BlinkMacSystemFont, sans-serif",
    soft: "'Uxum Grotesque', -apple-system, BlinkMacSystemFont, sans-serif",
    mono: "'JetBrains Mono', 'SFMono-Regular', Menlo, monospace",
    main: "'Uxum Grotesque', -apple-system, BlinkMacSystemFont, sans-serif",
    heading: "'Uxum Grotesque', -apple-system, BlinkMacSystemFont, sans-serif",
  },
  breakpoints: { sm: '576px', md: '768px', lg: '992px', xl: '1200px' },
  transitions: { default: '0.35s cubic-bezier(0.22, 1, 0.36, 1)' },
};

export { darkTheme, lightTheme, editorialTheme };
